"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TooltipArrow = function () {
    return (react_1.default.createElement("div", { style: $arrowContainer },
        react_1.default.createElement("span", { style: $tooltipArrow })));
};
var $arrowContainer = {
    position: 'relative',
};
var $tooltipArrow = {
    top: -5,
    position: 'absolute',
    borderWidth: 10,
    left: 'calc(50% - 10px)',
    borderColor: 'transparent',
    borderBottom: '10px solid #fcf1d9',
    zIndex: 200,
};
exports.default = TooltipArrow;
